import Dashboard from "@/components/Dashboard/Dashboard";
import Home from "@/components/Home/Home";
import ForgotOperator from "@/components/Login/ForgotOperator";
import ForgotPassword from "@/components/Login/ForgotPassword";
import Login from "@/components/Login/Login";
import RequestNewOperator from "@/components/Login/RequestNewOperator";
import ProductDetails from "@/components/Product/ProductDetails";
import Logout from "@/components/Logout/Logout";
import ProductList from "@/components/Product/ProductList";
import ChangePassword from "@/components/Profile/ChangePassword";
import UpdateAccessLevel from "@/components/Profile/UpdateAccessLevel";
import UpdateContactInformation from "@/components/Profile/UpdateContactInformation";
import ApproveNewAccessRequest from "@/components/Admin/ApproveNewAccessRequest";
import UpdateOperatorInformation from "@/components/Admin/UpdateOperatorInformation";
import InvestmentVehiclesProduct from "@/components/Product/InvestmentVehicles";
import ViewProductDetails from "@/components/Product/ViewProductDetails";
import RecordKeepers from "@/components/Admin/RecordKeeper/RecordKeepers";
import RecordKeeperDetails from "@/components/Admin/RecordKeeper/RecordKeeperDetails";
import ContactDetails from "@/components/Admin/RecordKeeper/ContactDetails";
import InsuranceCompaniesProduct from "@/components/Product/InsuranceCompanies";
import ProductRules from "@/components/Product/ProductRules";
import ProductManufacturers from "@/components/Admin/ProductManufacturer/ProductManufacturers";
import ContactDetailsProductManufacturer from "@/components/Admin/ProductManufacturer/ContactDetails";
import ProductManufacturerDetails from "@/components/Admin/ProductManufacturer/ProductManufacturerDetails";
import ProductManufacturerInsuranceCompanies from "@/components/Admin/ProductManufacturer/ProductManufacturerInsuranceCompanies";
import ProductManufacturerInvestmentVehicles from "@/components/Admin/ProductManufacturer/ProductManufacturerInvestmentVehicles";
import InvestmentVehicles from "@/components/Admin/InvestmentVehicles/InvestmentVehicles";
import InvestmentVehicleDetails from "@/components/Admin/InvestmentVehicles/InvestmentVehicleDetails";
import ManagementCompanyDetails from "@/components/Admin/InvestmentVehicles/ManagementCompanyDetails";
import InsuranceCompanyDetails from "@/components/Admin/InsuranceCompanies/InsuranceCompanyDetails";
import InsuranceCompanies from "@/components/Admin/InsuranceCompanies/InsuranceCompanies";
import InsuranceCompanyContactDetails from "@/components/Admin/InsuranceCompanies/ContactDetails";
import SetupPassword from "@/components/Login/SetupPassword";
import OwnerInquiry from "@/components/Owner/OwnerInquiry";
import SpouseDetailsProjection from "@/components/Owner/SpouseDetailsProjection";
import SpouseDobProjection from "@/components/Owner/SpouseDobProjection";
import AccountValueByVehicle from "@/components/Owner/AccountValueByVehicle";
import PaymentTable from "@/components/Product/PaymentTable";
import ContractCertificate from "@/components/Product/ContractAndCertificate/ContractCertificate";
import ContractCertificateDetails from "@/components/Product/ContractAndCertificate/ContractCertificateDetails";
import TransactionMatrix from "@/components/Product/TransactionMatrix";
import DuplicateProduct from "@/components/Product/DuplicateProduct";
import PurchaseTables from "@/components/Product/PurchaseTables";
import AddNewProduct from "@/components/Product/AddNewProduct";

export default Object.freeze({
  home: {
    component: <Home />,
    path: "/",
    isPrivate: false,
  },
  login: {
    component: <Login />,
    path: "/login",
    isPrivate: false,
  },
  logout: {
    component: <Logout />,
    path: "/logout",
    isPrivate: false,
  },
  forgotOperatorId: {
    component: <ForgotOperator />,
    path: "/forgot-operator-id",
    isPrivate: false,
  },
  forgotPassword: {
    component: <ForgotPassword />,
    path: "/forgot-password",
    isPrivate: false,
  },
  setupPassword: {
    component: <SetupPassword />,
    path: "/setup-password",
    isPrivate: false,
  },
  requestNewOperator: {
    component: <RequestNewOperator />,
    path: "/request-new-operator-access",
    isPrivate: false,
  },
  dashboard: {
    component: <Dashboard />,
    path: "/dashboard",
    isPrivate: true,
  },

  // PROFILE
  profileChangePassword: {
    component: <ChangePassword />,
    path: "/profile/change-password",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  updateContactInfo: {
    component: <UpdateContactInformation />,
    path: "/profile/update-contact-information",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  updateAccessLevel: {
    component: <UpdateAccessLevel />,
    path: "/profile/update-access-level",
    isPrivate: true,
    layout: "ClosableLayout",
  },

  // ADMIN
  approveNewAccessRequest: {
    component: <ApproveNewAccessRequest />,
    path: "/admin/approve-new-access-request",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  updateOperatorInformation: {
    component: <UpdateOperatorInformation />,
    path: "/admin/update-operator-information",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  recordKeepers: {
    component: <RecordKeepers />,
    path: "/admin/record-keepers",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  recordKeeperDetails: {
    component: <RecordKeeperDetails />,
    path: "/admin/record-keeper-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  recordKeeperContactDetails: {
    component: <ContactDetails />,
    path: "/admin/record-keeper-contact-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productManufacturers: {
    component: <ProductManufacturers />,
    path: "/admin/product-manufacturers",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productManufacturerDetails: {
    component: <ProductManufacturerDetails />,
    path: "/admin/product-manufacturer-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productManufacturerContactDetails: {
    component: <ContactDetailsProductManufacturer />,
    path: "/admin/product-manufacturer-contact-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productManufacturerInsuranceCompanies: {
    component: <ProductManufacturerInsuranceCompanies />,
    path: "/admin/product-manufacturer-insurance-companies",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productManufacturerInvestmentVehicles: {
    component: <ProductManufacturerInvestmentVehicles />,
    path: "/admin/product-manufacturer-investment-vehicles",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  investmentVehicles: {
    component: <InvestmentVehicles />,
    path: "/admin/investment-vehicles",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  investmentVehicleDetails: {
    component: <InvestmentVehicleDetails />,
    path: "/admin/investment-vehicle-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  managementCompanyDetails: {
    component: <ManagementCompanyDetails />,
    path: "/admin/management-company-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  insuranceCompanies: {
    component: <InsuranceCompanies />,
    path: "/admin/insurance-companies",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  insuranceCompanyDetails: {
    component: <InsuranceCompanyDetails />,
    path: "/admin/insurance-company-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  insuranceCompanyContactDetails: {
    component: <InsuranceCompanyContactDetails />,
    path: "/admin/insurance-company-contact-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },

  // PRODUCT
  productList: {
    component: <ProductList />,
    path: "/products",
    isPrivate: true,
    layout: "GridLayout",
  },
  productDetails: {
    component: <ProductDetails />,
    path: "/product/product-details",
    isPrivate: true,
  },
  investmentVehiclesProduct: {
    component: <InvestmentVehiclesProduct />,
    path: "/product/investment-vehicles",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  viewProductDetails: {
    component: <ViewProductDetails />,
    path: "/product/view-product-details/:id",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  insuranceCompaniesProduct: {
    component: <InsuranceCompaniesProduct />,
    path: "/product/insurance-companies",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  purchaseTables: {
    component: <PurchaseTables />,
    path: "/product/purchase-tables",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  productRules: {
    component: <ProductRules />,
    path: "/product/product-rules",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  paymentTable: {
    component: <PaymentTable />,
    path: "/product/payment-table",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  contractCertificate: {
    component: <ContractCertificate />,
    path: "/product/contract-certificate",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  contractCertificateDetails: {
    component: <ContractCertificateDetails />,
    path: "/product/contract-certificate-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  transactionMatrix: {
    component: <TransactionMatrix />,
    path: "/product/transaction-matrix",
    isPrivate: true,
    layout: "ClosableLayout",
  },

  duplicateProduct: {
    component: <DuplicateProduct />,
    path: "/product/copy-product/:id",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  addNewProduct: {
    component: <AddNewProduct />,
    path: "/product/add-new-product/:id",
    isPrivate: true,
    layout: "ClosableLayout",
  },

  // OWNER
  getOwnerInquiry: {
    component: <OwnerInquiry />,
    path: "/owner/owner-inquiry",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  accountValueByVehicle: {
    component: <AccountValueByVehicle />,
    path: "/owner/account-details-by-vehicle",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  projectionSpouseDob: {
    component: <SpouseDobProjection />,
    path: "/owner/projections/edit-projections",
    isPrivate: true,
    layout: "ClosableLayout",
  },
  projectionSpouseDetails: {
    component: <SpouseDetailsProjection />,
    path: "/owner/projections/spouse-details",
    isPrivate: true,
    layout: "ClosableLayout",
  },
});
